import { T } from '../strings'
import type { Theme } from '../theme'
import { formatDuration } from '../lib/dates'
import type { GameState } from '../game/types'
import { masteredPct, tableStats, todaySeconds, weakFacts, weekBars } from '../game/selectors'

interface Props {
  state: GameState
  theme: Theme
}

export default function ParentPanel({ state, theme }: Props) {
  const pct = masteredPct(state)
  const tables = tableStats(state, theme)
  const bars = weekBars(state, theme, T.weekDays as unknown as string[])
  const weak = weakFacts(state)

  return (
    <div>
      <p className="screen__sub" style={{ marginTop: 0 }}>
        {T.parentSub}
      </p>

      <div className="stat-row">
        <div className="stat-card">
          <div className="stat-card__value">{pct}%</div>
          <div className="stat-card__label">{T.learned}</div>
        </div>
        <div className="stat-card">
          <div className="stat-card__value">{formatDuration(todaySeconds(state))}</div>
          <div className="stat-card__label">{T.timeToday}</div>
        </div>
        <div className="stat-card">
          <div className="stat-card__value">🔥 {state.progress.streak}</div>
          <div className="stat-card__label">{T.streakWord(state.progress.streak)}</div>
        </div>
      </div>

      <div className="label" style={{ marginTop: 20 }}>
        {T.week}
      </div>
      <div className="week-bars">
        {bars.map((bar, i) => (
          <div key={i} className="week-col">
            <div className="week-bar" style={{ background: bar.bg, height: bar.height }} />
            <div
              className="week-col__day"
              style={{ color: bar.today ? theme.ink : theme.ink2 }}
            >
              {bar.day}
            </div>
          </div>
        ))}
      </div>

      <div className="label" style={{ marginTop: 20 }}>
        {T.byTable}
      </div>
      <div className="tables">
        {tables.map((table) => (
          <div key={table.n} className="table-row">
            <div className="table-row__n">{table.n}</div>
            <div className="bar">
              <div className="bar__fill" style={{ background: table.color, width: `${table.pct}%` }} />
            </div>
            <div className="table-row__pct">{table.pct}%</div>
          </div>
        ))}
      </div>

      <div className="card weak-card">
        <div className="label">{T.weak}</div>
        <div className="weak-list">
          {weak.length === 0 ? (
            <span className="screen__sub">{T.nothingYet}</span>
          ) : (
            weak.map((fact) => (
              <div key={fact.key} className="fact-tag">
                {fact.label}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}
